<template>
  <div :class="$style.container" :data-sku="sku">
    <div :class="$style.left">
      <NsImage
        :class="$style['product-image']"
        :src="image.src"
        :alt="image.alt"
        :fallback-src="imageFallbackSrc"
        maintain-ratio="1x1"
        image-fit="contain"
        size-lock="2"
      />

      <div :class="$style['product-title']" v-html="title" />

      <!-- @slot The 'left' slot is to added additional components within the left/product data area -->
      <slot name="left"></slot>
    </div>

    <div :class="$style.right">
      <!-- @slot The default slot is to add additional components to the right, usually actionable components -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
import NsProductMixin from "../mixins/NsProductMixin.js";
import NsImage from "./NsImage.vue";

/**
 * NsProductLine
 *
 * How to use: Any variables used in the template that are not props in this
 * component come from the mixin.
 */

export default {
  name: "NsProductLine",
  components: {
    NsImage
  },
  // Note: The current usage of this component to require the product mixin
  // is overkil but plan to expand to use for the seach with pricing/add to cart
  mixins: [NsProductMixin],
  data() {
    return {
      referrer: "productLine"
    };
  }
};
</script>

<style module lang="scss">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";

.container,
.left,
.right {
  position: relative;
  display: flex;
  align-items: center;
}

.container {
  color: map.get(colors.$themeColors, color-primary-text);
  width: 100%;
}

.left,
.right {
  > * {
    margin-left: 15px;
  }
}

.left {
  flex: 1;
}

.right {
  > *:last-child {
    margin-right: 15px;
  }
}

.product-image {
  max-height: 38px;
  max-width: 38px;
}

.product-title {
  font-size: 13px;
  font-weight: normal;
}
</style>
